import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import queryString from "query-string";
import { getServerErrorString } from "utils/common";

export const getAllRestrictions = (callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request("ProductRestrictions", "get", null, true, null)
      .then((res) => {
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const getRestrictionsById = (id, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`ProductRestrictions/${id}`, "get", null, true, null)
      .then((res) => {
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const createRestriction = (values, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`ProductRestrictions`, "post", values, true)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Restriction created successfully"
        );
        return { status: "success", data: res?.data };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const deleteRestriction = (id, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `ProductRestrictions/Status?productRestrictionId=${id}`,
      "PATCH",
      null,
      true
    )
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Restriction changed successfully"
        );
        callback?.();
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const updateRestrictions = (id, data, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`ProductRestrictions/${id}`, "put", data, true)
      .then(() => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Restriction updated successfully"
        );
        callback?.();
        return {
          status: "success",
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
export const validateRestriction = (values, facilityId, orderId) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    const qs = queryString.stringify({
      facilityId,
      orderId,
    });
    return request(`Orders/Validate?${qs}`, "post", values, true)
      .then((res) => {
        return { mstatus: true };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
        return { mstatus: false };
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
var DATA = [];
